import React from 'react';
import type { FC } from 'react';
import { Box, Spinner } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';

export const RegisteringApp: FC = () => {
  const { t } = useTranslation();

  return (
    <Box marginTop={1}>
      <Spinner text={t('create_app.create_new.registering_your_app')} />
    </Box>
  );
};
